import React from 'react';
import { ListType } from '../constants/listTypes';
import './ListSelectionModal.css';

export default function ListSelectionModal({ isOpen, lists, currentListId, onSelectList, onClose }) {
  if (!isOpen) return null;

  // Filter out the current list and special lists (main/tomorrow) - only show user-created lists
  const availableLists = lists.filter(list => 
    list.id !== currentListId && list.list_type === ListType.USER_LIST
  );

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content list-selection-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3 className="modal-title">Move Task to List</h3>
        </div>
        <div className="modal-body">
          {availableLists.length === 0 ? (
            <p className="list-selection-empty">No other lists available</p>
          ) : (
            <ul className="list-selection-list">
              {availableLists.map(list => (
                <li key={list.id}>
                  <button
                    className="list-selection-item"
                    onClick={() => onSelectList(list.id)}
                  >
                    <span className="list-selection-item-name">{list.name}</span>
                    <span className="list-selection-item-count">
                      {list.tasks?.length || 0} tasks
                    </span>
                  </button>
                </li>
              ))}
            </ul>
          )}
        </div>
        <div className="modal-footer">
          <button
            onClick={onClose}
            className="btn-custom btn-secondary-custom"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}

